const parties = {
    '«АТА МЕКЕН» саясий социалисттик партиясы': "Ата Мекен",
    '«АФГАНИСТАН СОГУШУНУН АРДАГЕРЛЕРИ ЖАНА УШУЛ СЫЯКТУУ КАГЫШУУЛАРГА КАТЫШКАНДАРДЫН САЯСИЙ ПАРТИЯСЫ»' : "Политическая партия ветеранов войны в Афганистане и участников других боевых конфликтов",
    '«БИР БОЛ»' : "Бир Бол",
    '«БИРИМДИК»' : "Биримдик",
    '«БҮТҮН КЫРГЫЗСТАН» саясий партиясы' : "Бутун Кыргызстан",
    '«ЗАМАНДАШ»' : "Замандаш",
    '«КЫРГЫЗСТАН»' : "Кыргызстан",
    '«МЕКЕН ЫНТЫМАГЫ»' : "Мекен Ынтымагы",
    '«МЕКЕНИМ КЫРГЫЗСТАН»': "Мекеним Кыргызстан",
    '«МЕКЕНЧИЛ»' : "Мекенчил",
    '«ОРДО»' : "Ордо",
    '«РЕФОРМА» партиясы' : "Реформа",
    '«ЧОҢ КАЗАТ»': "Чон казат",
    '«ЫЙМАН НУРУ»' : "Ыйман Нуру",
    'БААРЫНА КАРШЫ' : "Против всех",
    'РЕСПУБЛИКА' :"Республика",
    'СОЦИАЛ-ДЕМОКРАТТАР' : "Социал-демократы"
}

const partiesForMap = {
    '«АТА МЕКЕН» саясий социалисттик партиясы': "Ата Мекен",
    '«АФГАНИСТАН СОГУШУНУН АРДАГЕРЛЕРИ ЖАНА УШУЛ СЫЯКТУУ КАГЫШУУЛАРГА КАТЫШКАНДАРДЫН САЯСИЙ ПАРТИЯСЫ»' : "ППВВвАиУДБК",
    '«БИР БОЛ»' : "Бир Бол",
    '«БИРИМДИК»' : "Биримдик",
    '«БҮТҮН КЫРГЫЗСТАН» саясий партиясы' : "Бутун Кыргызстан",
    '«ЗАМАНДАШ»' : "Замандаш",
    '«КЫРГЫЗСТАН»' : "Кыргызстан",
    '«МЕКЕН ЫНТЫМАГЫ»' : "Мекен Ынтымагы",
    '«МЕКЕНИМ КЫРГЫЗСТАН»': "Мекеним Кыргызстан",
    '«МЕКЕНЧИЛ»' : "Мекенчил",
    '«ОРДО»' : "Ордо",
    '«РЕФОРМА» партиясы' : "Реформа",
    '«ЧОҢ КАЗАТ»': "Чон казат",
    '«ЫЙМАН НУРУ»' : "Ыйман Нуру",
    'БААРЫНА КАРШЫ' : "Против всех",
    'РЕСПУБЛИКА' :"Республика",
    'СОЦИАЛ-ДЕМОКРАТТАР' : "Социал-демократы"
}

const matchParty = (title) => {
    if (title in parties) {
        return parties[title]
    }
    else {
        return title
    }      
}

export const matchPartyForMap = (title) => {
    if (title in partiesForMap) {
        return partiesForMap[title]
    }
    else {
        return title
    }      
}

export default matchParty;